import React from "react";
import { baseURL } from "../../util/config";

export const img = (p) => (!p ? "" : p.startsWith("http") ? p : `${baseURL}${p.replace(/^\//, "")}`);

export const fmt = (n) => (Number(n) || 0).toLocaleString("tr-TR");

export const when = (d) =>
  d ? new Date(d).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—";

export const PageHead = ({ title, sub, right }) => (
  <div className="badu-page-head">
    <div>
      <h4>{title}</h4>
      {sub && <div className="sub">{sub}</div>}
    </div>
    {right}
  </div>
);

export const Tiles = ({ items }) => (
  <div className="badu-bento" style={{ marginBottom: 12 }}>
    {items.map((t) => (
      <div className="badu-tile" key={t.label}>
        <p className="badu-lbl">{t.label}</p>
        <div className="badu-val">{t.value}</div>
      </div>
    ))}
  </div>
);

export const Person = ({ p, image, name }) => {
  const src = img(image ?? p?.image);
  return (
    <div className="d-flex align-items-center" style={{ gap: 8 }}>
      {src ? <img className="table_image" src={src} alt="" /> : null}
      <b>{name ?? p?.name ?? "—"}</b>
    </div>
  );
};

export const Chip = ({ kind = "ok", children }) => <span className={`badu-chip ${kind}`}>{children}</span>;

export const Table = ({ head, rows, loading, empty = "Kayıt yok." }) => (
  <div className="card">
    <div className="card-body">
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              {head.map((h) => (
                <th key={h}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={head.length}>
                  <div className="badu-empty">Yükleniyor…</div>
                </td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td colSpan={head.length}>
                  <div className="badu-empty">{empty}</div>
                </td>
              </tr>
            ) : (
              rows
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export const Pager = ({ page, size, total, onChange }) => {
  const pages = Math.max(1, Math.ceil((total || 0) / size));
  return (
    <div className="d-flex justify-content-between align-items-center" style={{ marginTop: 10, fontSize: 13 }}>
      <span style={{ color: "#6B7280" }}>
        Toplam {fmt(total)} kayıt · Sayfa {page}/{pages}
      </span>
      <div className="d-flex" style={{ gap: 6 }}>
        <button className="btn btn-outline-secondary btn-sm" disabled={page <= 1} onClick={() => onChange(page - 1)}>
          Önceki
        </button>
        <button className="btn btn-outline-secondary btn-sm" disabled={page >= pages} onClick={() => onChange(page + 1)}>
          Sonraki
        </button>
      </div>
    </div>
  );
};

export const Tabs = ({ tabs, value, onChange }) => (
  <div className="d-flex" style={{ gap: 6, marginBottom: 12, flexWrap: "wrap" }}>
    {tabs.map(([k, label]) => (
      <button
        key={k}
        type="button"
        className={`btn btn-sm ${value === k ? "btn-primary" : "btn-outline-secondary"}`}
        onClick={() => onChange(k)}
      >
        {label}
      </button>
    ))}
  </div>
);

export const Modal = ({ open, title, onClose, children, wide }) =>
  !open ? null : (
    <div
      onClick={onClose}
      style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,.45)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="card"
        style={{ width: "100%", maxWidth: wide ? 900 : 520, maxHeight: "88vh", overflow: "auto", margin: 0 }}
      >
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: 12 }}>
            <h5 style={{ margin: 0 }}>{title}</h5>
            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onClose}>
              Kapat
            </button>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
